// extracted by mini-css-extract-plugin
export default {"qr":"qr__bgeDH"};